import { useState, } from 'react';

import { Button, Form, Col, } from 'react-bootstrap';
import { makeStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';
import { green } from '@material-ui/core/colors';
import SaveIcon from '@material-ui/icons/Save';

import ToastAnimated, { showToast, } from '../../ui-lib/toast';
import 'react-toastify/dist/ReactToastify.css';

import { ContractType, } from '../../entities/company';


const useStyles = makeStyles((theme) => ({
  wrapper: {
    margin: theme.spacing(1),
    position: 'relative',
  },
  buttonProgress: {
    color: green[500],
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -10,
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
  table: {
    minWidth: 300,
  },
}))


const DEFAULT_DATA = Object.freeze({
  name: '',
  pacote: '',
  contrato: ContractType.CONTRACT,
});


function CompanyForm({ onSubmit, loading, }) {
  const classes = useStyles();
  const [formData, setFormData] = useState(DEFAULT_DATA);
  const [borderError, setBorderError] = useState('');


  function _onSubmit() {
    if (!formData.name) {
      showToast({
        type: 'error',
        message: 'A empresa precisa de um nome',
      })
      return setBorderError('#ff0000');
    }

    setBorderError('');

    if (!loading) {
      onSubmit(formData);
      setFormData(DEFAULT_DATA);
    }
  }

  function handleChange(event) {
    setFormData({
      ...formData,
      [event.target.name]: event.target.value,
    });
  }


  return (
    <Form>
      <Form.Row>
        <Form.Group as={Col}>
          <Form.Label>
            Nome
          </Form.Label>
          <Form.Control
            style={{
              borderColor: borderError,
            }}
            type="email"
            placeholder="Nome"
            name="name"
            value={formData.name}
            onChange={handleChange}
          />
        </Form.Group>
      </Form.Row>

      <Form.Row>
        <Form.Group as={Col}>
          <Form.Label>
            Pacote de horas
          </Form.Label>
          <Form.Control
            as="select"
            name="pacote"
            value={formData.pacote}
            onChange={handleChange}
          >
            <option value={''} >Choose...</option>
            <option value={'300'} >300</option>
            <option value={'600'} >600</option>
          </Form.Control>
        </Form.Group>

        <Form.Group as={Col}>
          <Form.Label>
            Tipo do Contrato
          </Form.Label>
          <Form.Control
            as="select"
            name="contrato"
            value={formData.contrato}
            onChange={handleChange}
          >
            <option>Choose...</option>
            {
              Object.values(ContractType)
                .map((contractType) => {
                  return (
                    <option key={contractType}>
                      {contractType}
                    </option>
                  );
                })
            }
          </Form.Control>
        </Form.Group>
      </Form.Row>

      <div className={classes.wrapper}>
        <ToastAnimated />
        <Button
          variant="dark"
          disabled={loading}
          onClick={_onSubmit}
        >
          <SaveIcon /> Salvar
        </Button>
        {
          loading ?
          <CircularProgress
            size={24}
            className={classes.buttonProgress}
          /> :
          null
        }
      </div>
    </Form>
  );
}

export default CompanyForm;
